import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyCalenderEvents } from "../appState/slices/appointment/appointmentSlice";
import { MyApTDetails } from "../components";

const MyAppointments = () => {

  const dispatch = useDispatch();

  const appointments = useSelector(
    (state) => state.appointment.myAppointments
  );


  useEffect(() => {
    dispatch(getMyCalenderEvents());
  }, [dispatch]);

  return (

    <div className="appointments-page">
        <MyApTDetails appointments={appointments} />

    </div>

  );
};

export default MyAppointments;